import React from 'react'

function index() {
    return (
        <>
            <div className='abouthero px-4 wow animate__fadeInUp' data-wow-duration="1s" style={{ marginTop: '200px' }}>
                <h2 className='aimtext'>Aim for<span className='perfectiontext'> Perfection</span></h2>
                <p className='largeparagraph '>We deliver beautifully engineered Web and Mobile Applications with compatible and adaptable technologies for
                    the ever-evolving world. Our mission is to deliver modern software development that meets your needs.
                    We provide objective and project-based estimates so that you can deliver on time, on budget, with the
                    highest-quality code. We have developed deep industry knowledge in the latest technologies to create a superior product that you can be proud of! We deliver perfection with love.</p>
            </div>
            <div className='maincard px-4 wow animate__fadeInUp' data-wow-duration="1s">
                <div className='card'>
                    <div className='innercard'>
                        <div className='textcard1'>
                            <strong>$98M</strong>
                            <span className='plussign'>+</span>
                        </div>
                        <div className='textcard2'>Revenue Generated</div>
                    </div>
                </div>
                <div className='card'>
                    <div className='innercard'>
                        <div className='textcard1'> 
                            <strong>$5,387</strong>
                            <span className='plussign'>+</span>
                        </div>
                        <div className='textcard2'>  Projects Completed </div>
                    </div>
                </div>
                <div className='card'>
                    <div className='innercard'>
                        <div className='textcard1'> 
                            <strong>$1254</strong>
                            <span className='plusign1'>+</span>
                        </div>
                        <div className='textcard2'> Total Clients</div>
                    </div>
                </div>
                <div className='card'>
                    <div className='innercard'>
                        <div className='textcard1'> 
                            <strong> 476k</strong>
                            <span className='plusign2'>+</span>
                          

                        </div>
                        <div className='textcard2'> Hours of Expertise</div>
                    </div>
                </div>
                
            </div>
        </>
    )
}

export default index